function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function inserted(el, binding) {
  var _ref = binding.modifiers || {},
    _ref$self = _ref.self,
    self = _ref$self === void 0 ? false : _ref$self;
  var value = binding.value;
  var options = _typeof(value) === 'object' && value.options || {
    passive: true
  };
  var handler = typeof value === 'function' || 'handleEvent' in value ? value : value.handler;
  var target = self ? el : binding.arg ? document.querySelector(binding.arg) : window;
  if (!target) return;
  target.addEventListener('scroll', handler, options);
  el._onScroll = {
    handler: handler,
    options: options,
    // Don't reference self
    target: self ? undefined : target
  };
}
function unbind(el) {
  if (!el._onScroll) return;
  var _el$_onScroll = el._onScroll,
    handler = _el$_onScroll.handler,
    options = _el$_onScroll.options,
    _el$_onScroll$target = _el$_onScroll.target,
    target = _el$_onScroll$target === void 0 ? el : _el$_onScroll$target;
  target.removeEventListener('scroll', handler, options);
  delete el._onScroll;
}
export var Scroll = {
  inserted: inserted,
  unbind: unbind
};
export default Scroll;